import { Button, CommentIcon } from 'ui';

type P = {
  onShowComments?: () => void;
};

const CommentButton = ({ onShowComments }: P) => {
  return (
    <div className="comment-button">
      <Button
        item={{
          type: 'text',
          icon: <CommentIcon className="comment-button__icon" />,
          className: 'comment-button__button',
          onClick: onShowComments,
        }}
      >
        Comment
      </Button>
    </div>
  );
};

export default CommentButton;
